import { Bell, CircleAlert, FileClock, Route, ShieldAlert, UserPlus } from 'lucide-react';

const iconMap = { audit: FileClock, security: ShieldAlert, notification: Bell, member: UserPlus, trip: Route };
const toneMap = {
  success: 'border-emerald-400/30 bg-emerald-400/10 text-emerald-300',
  warning: 'border-amber-400/30 bg-amber-400/10 text-amber-300',
  critical: 'border-rose-400/30 bg-rose-400/10 text-rose-300',
  info: 'border-cyan-400/30 bg-cyan-400/10 text-cyan-300',
  neutral: 'border-white/10 bg-white/[.035] text-slate-300',
};

export function ActivityFeed({ items = [], compact = false }) {
  if (!items.length) return <div className="grid min-h-32 place-items-center text-[9px] font-bold uppercase tracking-[.18em] text-slate-600">No activity</div>;
  return <div className="relative">
    <span className={`absolute bottom-4 top-4 w-px bg-gradient-to-b from-cyan-400/30 via-white/10 to-transparent ${compact ? 'left-[16px]' : 'left-[19px]'}`}/>
    <div className="space-y-px">{items.map((item) => <ActivityItem key={item.id ?? item._id} item={item} compact={compact}/>)}</div>
  </div>;
}

function ActivityItem({ item, compact }) {
  const Icon = iconMap[item.kind] ?? CircleAlert;
  const date = item.createdAt ? new Date(item.createdAt) : null;
  const layout = compact
    ? 'grid-cols-[32px_1fr_auto] gap-2 px-1.5 py-2'
    : 'grid-cols-[40px_1fr_auto] gap-3 px-2 py-3';
  const iconSize = compact ? 'size-7' : 'size-9';
  return <div className={`group relative grid ${layout} hover:bg-white/[.025]`}>
    <div className={`relative z-10 grid ${iconSize} place-items-center border ${toneMap[item.tone] ?? toneMap.neutral}`}><Icon size={compact ? 12 : 15}/></div>
    <div className="min-w-0 self-center">
      <div className="flex items-center gap-2"><p className={`truncate font-semibold text-slate-100 capitalize ${compact ? 'text-[10px]' : 'text-sm'}`}>{item.title}</p>{item.actorRole && <span className="border border-white/10 px-1.5 py-0.5 text-[7px] font-bold uppercase tracking-[.12em] text-slate-500">{item.actorRole}</span>}</div>
      {!compact && item.description && <p className="mt-1 line-clamp-2 text-xs leading-5 text-slate-500">{item.description}</p>}
      {!compact && item.targetType && <p className="mt-1 text-[10px] uppercase tracking-[.14em] text-slate-600">{item.targetType}</p>}
    </div>
    <time className={`self-start pt-0.5 font-medium tabular-nums text-slate-600 ${compact ? 'text-[8px]' : 'text-[10px]'}`}>{date ? relativeTime(date) : ''}</time>
  </div>;
}

function relativeTime(date) {
  const seconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}
